module.exports = __webpack_public_path__ + "img/1581465220.e6ecef03.jpg";